import { render, staticRenderFns } from "./ModifiersPanel.vue?vue&type=template&id=5da00983&"
import script from "./ModifiersPanel.vue?vue&type=script&lang=js&"
export * from "./ModifiersPanel.vue?vue&type=script&lang=js&"
import style0 from "./ModifiersPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports